import { SESSION_PATHS, sessionUrl } from '@words-happen/app-urls';

/** POST /session/sign-out on words-happen-gql: clears both session cookies. Rejects when it fails. */
export type EndSession = () => Promise<void>;

export const createEndSession =
  (apiOrigin: string = API_ORIGIN, fetchImpl: typeof fetch = (...args) => fetch(...args)): EndSession =>
  async () => {
    const response = await fetchImpl(sessionUrl(apiOrigin, SESSION_PATHS.signOut), {
      method: 'POST',
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error(`Sign-out failed with ${response.status}`);
    }
  };
